import { useEffect, useState } from "react";
import api, { fileUrl } from "@/api";

/** Fetch all stores once and expose { [id]: imageUrl } — cached in localStorage. */
const CACHE_KEY = "tf_store_images_v1";

export function useStoreImages() {
  const [map, setMap] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CACHE_KEY) || "{}"); } catch { return {}; }
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const stores = ["jannelli", "mazzini", "materdomini", "parafarmacia"];
        const results = await Promise.all(stores.map((s) => api.get(`/stores/${s}`).then((r) => [s, r.data]).catch(() => [s, null])));
        if (cancelled) return;
        const out = {};
        for (const [id, doc] of results) {
          if (!doc) continue;
          if (doc.image_url) out[id] = doc.image_url;
          else if (doc.image_file_id) out[id] = fileUrl(doc.image_file_id);
        }
        setMap(out);
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(out)); } catch { /* quota */ }
      } catch { /* offline */ }
    })();
    return () => { cancelled = true; };
  }, []);

  return map;
}
